import { useContext } from 'react';

import InfoContext from '#src/contexts/info.tsx';

export const ErrorFallback = () => {
  const { dict } = useContext(InfoContext)!;
  return (
    <div role="alert">
      <p>{dict.errorTrackingTitle}</p>
      <p>{dict.errorTrackingBody}</p>
    </div>
  );
};
